<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Тип рецепта
        td {{this.formatAnswer(data.body.content.prescription_type, 3)}}
          span(v-if="data.body.content.prescription_type")
            span(v-if="data.body.content.is_by_benefit===true")
              b &nbsp;(льготный)
            span(v-show="data.body.content.is_by_medical_commission===true") (выдан на ВК)
      tr
        td Диагноз
        td {{this.formatAnswer(data.body.content.diagnosis, 2)}} ({{this.formatAnswer(data.body.content.diagnosis_code, 2)}})
      tr
        td Серия/номер
        td {{this.formatAnswer(data.body.content.series, 2)}} / {{this.formatAnswer(data.body.content.number, 2)}}
      tr
        td МНН
        td
          span(v-if="data.body.content.act_matter") {{this.formatAnswer(data.body.content.act_matter, 2)}} <br>
          span {{this.formatAnswer(data.body.content.act_matter_rus, 2)}} ({{this.formatAnswer(data.body.content.act_matter_lat, 2)}})
      tr
        td Торговое наименование
        td {{this.formatAnswer(data.body.content.trade_name_rus, 2)}} ({{this.formatAnswer(data.body.content.trade_name_lat, 2)}})
      tr
        td Форма выпуска
        td {{this.formatAnswer(data.body.content.drug_form, 2)}}
      tr
        td Лекарственная форма
        td {{this.formatAnswer(data.body.content.med_form, 2)}}
      //- tr(v-if="!data.body.content.nomen")
      //-   td Идентификатор упаковки препарата
      //-   td {{this.formatAnswer(data.body.content.nomen, 2)}}
      tr
        td Дозировка
        td {{this.formatAnswer(data.body.content.dosage, 2)}}
      tr
        td Количество единиц в упаковке
        td {{this.formatAnswer(data.body.content.units_in_package, 2)}}
      tr
        td Выписанное количество
        td {{this.formatAnswer(data.body.content.prescribed_qty, 2)}} {{this.formatAnswer(data.body.content.prescribed_qty, 5, data.body.content.prescribed_qty_unit) | lowercase}}
      tr
        td Signa (кратность приема)
        td {{this.formatAnswer(data.body.content.signa, 2)}}
      tr
        td Срок действия
        td {{this.formatAnswer(data.body.content.expiration_date, 2)}}
      tr
        td Печать
        td {{this.formatAnswer(data.body.content.is_printed, 1)}}
      tr
        td Производитель
        td {{this.formatAnswer(data.body.content.producer, 2)}}
      tr
        td Рецепт был выдан на врачебной комиссии
        td {{this.formatAnswer(data.body.content.is_by_medical_commission, 6)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type, units) {
      switch (type) {
        case 1:
          return fact !== undefined
            ? fact
              ? 'Выполнена'
              : 'Не выполнена'
            : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
        case 5:
          return fact ? units : '—'
        case 6:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
